import { Validators } from '@angular/forms';

import { ClientStatusesEnum, IndividualFilterModel, IndividualReportModel } from '@spa/api';

import { ComponentTypesEnum, UnspecifiedKeysEnum } from '../../../app/shared/enums';
import { FilterControlInterface } from '../../../app/shared/interfaces';
import { ReportTableData, ReportTableConfigInterface, ReportTableColumn } from '../../../app/shared/components';
import { AutocompleteControl, BaseControl, Helper, SelectControl } from '../../../app/shared/classes';

import { EnrollDateSelector } from '../panel-leads.descriptor';
import { EnrollTypesEnum } from '../../../app/entries/panel/enums';

export const ClientIdSelector = 'clientId';
export const UserIdSelector = 'userId';
export const IsCorporateClientSelector = 'isCorporateCard';
export const CompaniesPathSelector = 'corporate';
export const IndividualPathSelector = 'individual';
export const ClientsReportRowIdSeparator = '|';
export const ClientVerificationDateSelector = 'clientVerificationDate';
export const PanelClientsStorageId = 'PanelClientsComponent';

export const PanelClientsFilterControls = (): FilterControlInterface[] => {
    return [
        {
            name: EnrollDateSelector,
            placeholder: 'Enroll date',
            controls: [
                new BaseControl({
                    name: IndividualFilterModel.getEnrollDateFromSelector(),
                    value: null,
                    placeholder: 'Enroll date from',
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 1
                }),
                new BaseControl({
                    name: IndividualFilterModel.getEnrollDateToSelector(),
                    value: null,
                    placeholder: 'Enroll date to',
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 2
                }),
            ],
            sortIndex: 1
        },
        {
            name: ClientVerificationDateSelector,
            placeholder: 'Verification date',
            controls: [
                new BaseControl({
                    name: IndividualFilterModel.getVerificationDateFromSelector(),
                    value: null,
                    placeholder: 'Verification date from',
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 1
                }),
                new BaseControl({
                    name: IndividualFilterModel.getVerificationDateToSelector(),
                    value: null,
                    placeholder: 'Verification date to',
                    validators: [],
                    componentType: ComponentTypesEnum.Datepicker,
                    sortIndex: 2
                })
            ],
            sortIndex: 2
        },
        {
            name: IndividualFilterModel.getOldClientIdSelector(),
            placeholder: 'Old Client Id',
            controls: [
                new BaseControl({
                    name: IndividualFilterModel.getOldClientIdSelector(),
                    value: null,
                    placeholder: 'Old Client Id',
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                }),
            ],
            sortIndex: 3
        },
        {
            name: IndividualFilterModel.getStatusesSelector(),
            placeholder: 'Status',
            controls: [
                new SelectControl({
                    name: IndividualFilterModel.getStatusesSelector(),
                    value: ClientStatusesEnum.All,
                    placeholder: 'Status',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: []
                }),
            ],
            sortIndex: 4
        },
        {
            name: IndividualFilterModel.getEnrollTypeSelector(),
            placeholder: 'Client Type',
            controls: [
                new SelectControl({
                    name: IndividualFilterModel.getEnrollTypeSelector(),
                    value: EnrollTypesEnum.All,
                    placeholder: 'Client Type',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: Helper.textsHelper().getEnrollTypeName(EnrollTypesEnum.All),
                            value: EnrollTypesEnum.All
                        },
                        {
                            label: Helper.textsHelper().getEnrollTypeName(EnrollTypesEnum.Individual),
                            value: EnrollTypesEnum.Individual
                        },
                        {
                            label: Helper.textsHelper().getEnrollTypeName(EnrollTypesEnum.Corporate),
                            value: EnrollTypesEnum.Corporate
                        },
                    ]
                })
            ],
            sortIndex: 5
        },
        {
            name: IndividualFilterModel.getNameSelector(),
            placeholder: 'Name',
            controls: [
                new BaseControl({
                    name: IndividualFilterModel.getNameSelector(),
                    value: null,
                    placeholder: 'Name',
                    validators: [Validators.minLength(3)],
                    componentType: ComponentTypesEnum.Text
                }),
            ],
            sortIndex: 6
        },
        {
            name: IndividualFilterModel.getEmailSelector(),
            placeholder: 'Email',
            controls: [
                new BaseControl({
                    name: IndividualFilterModel.getEmailSelector(),
                    value: null,
                    placeholder: 'Email',
                    validators: [],
                    componentType: ComponentTypesEnum.Text
                }),
            ],
            sortIndex: 7
        },
        {
            name: IndividualFilterModel.getCountryIdSelector(),
            placeholder: 'Country',
            controls: [
                new AutocompleteControl({
                    name: IndividualFilterModel.getCountryIdSelector(),
                    value: null,
                    placeholder: 'Country',
                    validators: [],
                    componentType: ComponentTypesEnum.Autocomplete,
                    options: []
                }),
            ],
            sortIndex: 8
        },
        {
            name: IndividualFilterModel.getEnrollPortalIdsSelector(),
            placeholder: 'Portal',
            controls: [
                new SelectControl({
                    name: IndividualFilterModel.getEnrollPortalIdsSelector(),
                    value: UnspecifiedKeysEnum.UnspecifiedPortalIdKey,
                    placeholder: 'Portal',
                    validators: [],
                    componentType: ComponentTypesEnum.Select,
                    options: [
                        {
                            label: 'All',
                            value: UnspecifiedKeysEnum.UnspecifiedPortalIdKey
                        }
                    ]
                })
            ],
            sortIndex: 9
        },
    ];
};


export const PanelClientsDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: IndividualReportModel.getEnrollDateSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: IndividualReportModel.getVerificationDateSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: IndividualReportModel.getOldClientIdSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<number>({
            colId: IndividualReportModel.getStatusNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: IndividualReportModel.getEnrollTypeSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: IndividualReportModel.getFirstNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: IndividualReportModel.getLastNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: IndividualReportModel.getNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: IndividualReportModel.getEmailSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: IndividualReportModel.getCountryNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: IndividualReportModel.getEnrollPortalNameSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: IndividualReportModel.getBirthDateSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: IndividualReportModel.getLeiCodeSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: IndividualReportModel.getMifirNumberSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: IndividualReportModel.getMifirTypeSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: IndividualReportModel.getNationalitiesSelector(),
            value: null,
            hidden: false
        }),
    ];
};

export const PanelClientsDataTableConfig = (): ReportTableConfigInterface => {
    return {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'Enroll date',
                selector: IndividualReportModel.getEnrollDateSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Verification date',
                selector: IndividualReportModel.getVerificationDateSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Old Client Id',
                selector: IndividualReportModel.getOldClientIdSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Status',
                selector: IndividualReportModel.getStatusNameSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Client Type',
                selector: IndividualReportModel.getEnrollTypeSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'First Name',
                selector: IndividualReportModel.getFirstNameSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Last Name',
                selector: IndividualReportModel.getLastNameSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Name',
                selector: IndividualReportModel.getNameSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Email',
                selector: IndividualReportModel.getEmailSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Country',
                selector: IndividualReportModel.getCountryNameSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Portal',
                selector: IndividualReportModel.getTypeBehaviorNameSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Birth Date',
                selector: IndividualReportModel.getBirthDateSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'LEI Code',
                selector: IndividualReportModel.getLeiCodeSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'MiFIR Number',
                selector: IndividualReportModel.getMifirNumberSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'MiFIR Type',
                selector: IndividualReportModel.getMifirTypeSelector(),
                sortable: true
            }),
            new ReportTableColumn({
                label: 'Nationalities',
                selector: IndividualReportModel.getNationalitiesSelector(),
                sortable: false
            }),
        ],
        hiddenColumnIds: [],
        actionMenu: false
    };
};
